export default __webpack_public_path__ + "static/Vumography-BG1-4cf95650d2d3961baf686409793a8a39.webp";